














import Vue from "vue";
export default Vue.extend({
  name: "c-empty-filter",
  props: ["responseDescription", "value", "responseList"],

  methods: {
    prova(responseList: Record<string, any>) {
      const p = responseList;
      return p;
    }
  }
});
